import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Navbar.css";

/* ---------------- Navbar Component ---------------- */
const Navbar = ({ user, onSignOut, currentPage = "home" }) => {
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <header className="navbar-header">
      <div className="navbar-container">
        {/* Left: Hamburger + Logo + Desktop Nav */}
        <div className="navbar-left">
          {/* 1. Moved the mobile menu button here */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="mobile-menu-button"
          >
            {isMobileMenuOpen ? "✖" : "☰"}
          </button>

          {/* 2. Logo is now second */}
          <button onClick={() => navigate("/")} className="logo-button">
            <img
              src="/aisleaiagents.png"
              alt="Aisle Agent Logo"
              className="logo-image"
            />
          </button>
          
          <nav className="nav-desktop">
            <div className="navbar-links">
              {/* (All your <a> tags) */}
              <a
                href="/"
                className={`nav-link ${currentPage === "home" ? "active" : ""}`}
              >
                Home
              </a>
              <a
                href="/terms"
                className={`nav-link ${currentPage === "terms" ? "active" : ""}`}
              >
                Terms & Conditions
              </a>
              <a
                href="/privacy"
                className={`nav-link ${currentPage === "privacy" ? "active" : ""}`}
              >
                Privacy
              </a>
              <a
                href="/about"
                className={`nav-link ${currentPage === "about" ? "active" : ""}`}
              >
                About
              </a>
              <a
                href="/contact"
                className={`nav-link ${currentPage === "contact" ? "active" : ""}`}
              >
                Contact
              </a>
            </div>
          </nav>
        </div>

        {/* Right: Auth Button Only */}
        <div className="navbar-right">
          {user ? (
            <button onClick={onSignOut} className="auth-button">
              Sign Out
            </button>
          ) : (
            <img
              src="/SLTMobitel_Logo.png" 
              alt="Embryo Logo" 
              className="logo-image"
            />
          )}
          {/* 3. The mobile menu button was removed from here */}
        </div>
      </div>

      {/* Mobile Menu Dropdown */}
      {isMobileMenuOpen && (
        <div className="mobile-menu-dropdown">
          <nav className="nav-mobile">
            <div className="navbar-links-mobile">
              {/* (All your mobile <a> tags) */}
              <a
                href="/"
                className={`mobile-nav-link ${
                  currentPage === "home" ? "active" : ""
                }`}
              >
                Home
              </a>
              <a
                href="/terms"
                className={`mobile-nav-link ${
                  currentPage === "terms" ? "active" : ""
                }`}
              >
                Terms & Conditions
              </a>
              <a
                href="/privacy"
                className={`mobile-nav-link ${
                  currentPage === "privacy" ? "active" : ""
                }`}
              >
                Privacy
              </a>
              <a
                href="/about"
                className={`mobile-nav-link ${
                  currentPage === "about" ? "active" : ""
                }`}
              >
                About
              </a>
              <a
                href="/contact"
                className={`mobile-nav-link ${
                  currentPage === "contact" ? "active" : ""
                }`}
              >
                Contact
              </a>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Navbar;